module.exports = __webpack_public_path__ + "static/media/puzzle0102.c69bc7a1.png";